import { computed, type Signal, type Injector } from "@angular/core";

import type { BaseFilterDefinition, FilterDefinition, FilterMultiSelection, FilterValue } from "@shared/filter";
import { RoleUserFilterService } from "./roles.service";
import type { IBaseT1Card } from "@app/views-interfaces";
import type { IiFirmUserRolesWithUsersMap } from "@interfaces";

export class AssigneeFilter extends RoleUserFilterService<IBaseT1Card> {
    public override readonly definition: FilterDefinition<FilterMultiSelection>;
    private readonly role = computed(() => this.rolesWithUsers().get(this.roleId));

    constructor(
        protected readonly injector: Injector,
        protected readonly roleId: string,
        private readonly rolesWithUsers: Signal<IiFirmUserRolesWithUsersMap>,
    ) {
        super();
        this.definition = this.createDefinition();
    }

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: this.roleId,
            label: this.role?.()?.Description ?? this.roleId,
        };
    }

    protected getValue(item: IBaseT1Card): FilterValue | undefined {
        return item.roleUserMapping.find((mapping) => mapping.roleId === this.roleId)?.userId;
    }
}
